/**
 * Game Constants
 * 
 * All tile type constants and game configuration values.
 * Ported from louo.as
 */

// Terrain Types
export const WALL = 0x0005;
export const TOWN_HALL = 0x0006;
export const DEEP_WATER = 0x0007;
export const WATER = 0x0100;
export const LAND = 0x0200;

// Wood Resources and Buildings
export const WOOD = 0x1200;
export const CUTTER = 0x1201;
export const SAWMILL = 0x1202;
export const CUTTER_OLD = 0x1204;

// Stone Resources and Buildings
export const STONE = 0x2200;
export const QUARRY = 0x2201;
export const STONEMASON = 0x2202;
export const QUARRY_OLD = 0x2204;

// Iron Resources and Buildings
export const IRON = 0x3200;
export const MINE = 0x3201;
export const FOUNDRY = 0x3202;
export const MINE_OLD = 0x3204;

// Food Resources and Buildings
export const FOOD = 0x4200;
export const OPEN = 0x4200; // Same as FOOD
export const FARM = 0x4201;
export const MILL = 0x4202;
export const LAKE = 0x4203;
export const FARM_OLD = 0x4204;

// Gold Buildings
export const GOLD = 0x5200;
export const MANOR = 0x5205;
export const BAZAAR = 0x5207;
export const WHARF = 0x5106;

// Infrastructure
export const CASA = 0x6215;
export const CELLARIUM = 0x6216;
export const CACHE = 0x6217;

// Military Buildings
export const SHIPYARD = 0x7118;
export const BARRACKS = 0x7219;
export const CASTLE = 0x7225;
export const CITY_GUARD_HOUSE = 0x7226;
export const MOONGLOW = 0x7227;
export const STABLES = 0x7228;
export const TEMPLE = 0x7229;
export const TRAINING_GROUND = 0x7235;
export const WORKSHOP = 0x7236;

// Special
export const ANY = 0x8000;

// Terrain Masks
export const IS_WATER = 0x0100;
export const IS_LAND = 0x0200;
export const TERRAIN_TYPE = 0x0300;

// Optimization Types
export const DUMMY = 0x1ffff;
export const BASIC_GATHERER = 0x2ffff;
export const REFINER = 0x3ffff;

// Character mappings (for ShareString)
export const X = 0x0005; // Wall
export const x = 0x0006; // Town Hall
export const _ = 0x4200; // Open/Land
export const o = 0x0100; // Water
export const O = 0x0007; // Deep Water

/**
 * Zone map for city layout (21x21)
 * Defines zones for optimization
 */
export const ZONE = [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,1,1,1,1,1,1,1,0,2,2,2,2,2,2,2,0,0,0],
    [0,0,1,1,1,1,1,1,1,1,0,2,2,2,2,2,2,2,2,0,0],
    [0,1,1,1,1,1,1,1,1,1,0,2,2,2,2,2,2,2,2,2,0],
    [0,1,1,1,1,1,1,1,1,1,0,2,2,2,2,2,2,2,2,2,0],
    [0,1,1,1,1,1,1,0,0,0,0,0,0,0,2,2,2,2,2,2,0],
    [0,1,1,1,1,1,0,0,3,3,3,3,3,0,0,2,2,2,2,2,0],
    [0,1,1,1,1,0,0,3,3,3,3,3,3,3,0,0,2,2,2,2,0],
    [0,1,1,1,1,0,3,3,3,3,3,3,3,3,3,0,2,2,2,2,0],
    [0,1,1,1,1,0,3,3,3,3,3,3,3,3,3,0,2,2,2,2,0],
    [0,0,0,0,0,0,3,3,3,3,0,3,3,3,3,0,0,0,0,0,0],
    [0,4,4,4,4,0,3,3,3,3,3,3,3,3,3,0,5,5,5,5,0],
    [0,4,4,4,4,0,3,3,3,3,3,3,3,3,3,0,5,5,5,5,0],
    [0,4,4,4,4,0,0,3,3,3,3,3,3,3,0,0,5,5,5,5,0],
    [0,4,4,4,4,4,0,0,3,3,3,3,3,0,0,5,5,5,5,5,0],
    [0,4,4,4,4,4,4,0,0,0,0,0,0,0,5,5,5,5,5,5,0],
    [0,4,4,4,4,4,4,4,4,4,0,5,5,5,5,5,5,5,5,5,0],
    [0,4,4,4,4,4,4,4,4,4,0,5,5,5,5,5,5,5,5,5,0],
    [0,0,4,4,4,4,4,4,4,4,0,5,5,5,5,5,5,5,5,0,0],
    [0,0,0,4,4,4,4,4,4,4,0,5,5,5,5,5,5,5,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
];

/**
 * Land map template (21x21)
 */
export const LAND_MAP = [
    [X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X],
    [X,X,X,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,X,X,X],
    [X,X,_,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,_,X,X],
    [X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X],
    [X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X],
    [X,_,_,_,_,_,_,X,X,X,X,X,X,X,_,_,_,_,_,_,X],
    [X,_,_,_,_,_,X,X,_,_,_,_,_,X,X,_,_,_,_,_,X],
    [X,_,_,_,_,X,X,_,_,_,_,_,_,_,X,X,_,_,_,_,X],
    [X,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,X],
    [X,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,X],
    [X,X,X,X,X,X,_,_,_,_,x,_,_,_,_,X,X,X,X,X,X],
    [X,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,X],
    [X,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,X],
    [X,_,_,_,_,X,X,_,_,_,_,_,_,_,X,X,_,_,_,_,X],
    [X,_,_,_,_,_,X,X,_,_,_,_,_,X,X,_,_,_,_,_,X],
    [X,_,_,_,_,_,_,X,X,X,X,X,X,X,_,_,_,_,_,_,X],
    [X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X],
    [X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X],
    [X,X,_,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,_,X,X],
    [X,X,X,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,X,X,X],
    [X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X]
];

/**
 * Water map template (21x21)
 */
export const WATER_MAP = [
    [X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X],
    [X,X,X,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,X,X,X],
    [X,X,_,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,_,X,X],
    [X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X],
    [X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X],
    [X,_,_,_,_,_,_,X,X,X,X,X,X,X,_,_,_,_,_,_,X],
    [X,_,_,_,_,_,X,X,_,_,_,_,_,X,X,_,_,_,_,_,X],
    [X,_,_,_,_,X,X,_,_,_,_,_,_,_,X,X,_,_,_,_,X],
    [X,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,X],
    [X,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,X],
    [X,X,X,X,X,X,_,_,_,_,x,_,_,_,_,X,X,X,X,X,X],
    [X,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,X],
    [X,_,_,_,_,X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,X],
    [X,_,_,_,_,X,X,_,_,_,_,_,_,_,X,X,_,_,_,_,X],
    [X,_,_,_,_,_,X,X,_,_,_,_,_,X,X,_,_,_,_,_,X],
    [X,_,_,_,_,_,_,X,X,X,X,X,X,X,_,_,o,o,_,_,X],
    [X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,o,O,O,o,_,X],
    [X,_,_,_,_,_,_,_,_,_,X,_,_,_,_,o,O,O,O,o,X],
    [X,X,_,_,_,_,_,_,_,_,X,_,_,_,_,_,o,O,O,X,X],
    [X,X,X,_,_,_,_,_,_,_,X,_,_,_,_,_,_,o,X,X,X],
    [X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X,X]
];

/**
 * Helper functions to check tile types
 */
export function isBuilding(tile) {
    return (tile & 0x000f) && (tile !== LAKE) && (tile < ANY) && (tile > 0x1000);
}

export function isResource(tile) {
    return ((tile & 0x000f) === 0) || (tile === LAKE) || (tile === OPEN);
}

export function isRealResource(tile) {
    return ((tile & 0x000f) === 0) || (tile === LAKE);
}

export function isMilitary(tile) {
    return (tile >= SHIPYARD && tile <= WORKSHOP && tile !== BARRACKS);
}

